// eslint-disable-next-line import/no-extraneous-dependencies
import React, { createContext, useContext } from 'react'

export type CompToolMode = 'interactive' | 'export'

const ModeContext = createContext<CompToolMode>('interactive')

export function ModeProvider({
    mode,
    children,
}: {
    mode: CompToolMode
    children: React.ReactNode
}) {
    return <ModeContext.Provider value={mode}>{children}</ModeContext.Provider>
}

export function useMode() {
    return useContext(ModeContext)
}
